import { useTranslation } from "react-i18next";
import { IconlyMenuCloseLeft, IconlyMenuOpenRight } from "@/core/assets/icons";
import WobaWordmark from "@/core/assets/woba-wordmark.svg?react";
import {
  SidebarHeader as SidebarHeaderUI,
  useSidebar,
} from "@/core/components/ui/sidebar";
import { DS_COLOR, DS_TYPOGRAPHY } from "@/core/lib/ds-typography";
import { EVENTS, useActionsTrack } from "@/core/services/menu-analytics";

/** Button Icon ghost do DS (40×40, pílula) usado para recolher/expandir. */
const TOGGLE_CLASS =
  "flex size-10 shrink-0 items-center justify-center rounded-full hover:bg-[var(--woba-color-surface-common-hover)]";

export function WosSidebarHeader() {
  const { state, toggleSidebar, isMobile } = useSidebar();
  const [translate] = useTranslation(["core"]);
  const { onActionClick } = useActionsTrack();

  const isCollapsed = state === "collapsed";

  const onToggle = () => {
    onActionClick(
      (isCollapsed
        ? "MENU_SIDEBAR_EXPAND_CLICK"
        : "MENU_SIDEBAR_COLLAPSE_CLICK") as keyof typeof EVENTS,
      "MENU",
    );
    toggleSidebar();
  };

  // Figma (Sidebar 6051:2744 > Header): min 56px, logo "woba" + nome do produto
  // em Subheading/Medium e Button Icon de recolher à direita. Recolhida, só o
  // botão de expandir fica visível, centralizado na coluna de ícones.
  return (
    <SidebarHeaderUI
      className={`min-h-14 justify-center gap-0 p-0 py-1 ${
        isCollapsed ? "items-center px-1" : "pl-4 pr-1"
      }`}
    >
      <div
        className={`flex items-center gap-2 ${isCollapsed ? "justify-center" : "justify-between"}`}
      >
        {!isCollapsed && (
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <WobaWordmark
              aria-hidden
              className="shrink-0"
              style={{ width: 52.6, height: 16, display: "block" }}
            />
            <span
              className="truncate"
              style={{
                ...DS_TYPOGRAPHY.subheadingMedium,
                color: DS_COLOR.contentSubtle,
              }}
            >
              {translate("app-name")}
            </span>
          </div>
        )}

        {!isMobile && (
          <button
            type="button"
            aria-label={
              translate(
                isCollapsed ? "app-menu-expand" : "app-menu-collapse",
              ) as string
            }
            onClick={onToggle}
            className={TOGGLE_CLASS}
            data-testid="wos-sidebar-toggle"
          >
            <span
              className="flex shrink-0 items-center justify-center"
              style={{ width: 20, height: 20 }}
            >
              {isCollapsed ? (
                <IconlyMenuOpenRight size={20} color={DS_COLOR.contentSubtle} />
              ) : (
                <IconlyMenuCloseLeft size={20} color={DS_COLOR.contentSubtle} />
              )}
            </span>
          </button>
        )}
      </div>
    </SidebarHeaderUI>
  );
}
